import React, { Component } from 'react';
import {
  LoginErrorText,
  LoginFormTitle,
  LoginInputField,
  LoginInputLabel,
  StyledLoginForm,
  LoginLink
} from '../style-guide/Login';
import { Button } from './CommonUiComponents';
import { Link } from 'react-router-dom';
import findIdByPath from '../utils/findIdByPath';

export default class LoginNewPassword extends Component {
  state = {
    password: '',
    passwordReset: false
  };

  handleNewPassword = async e => {
    const { newPassword, resetKey, email } = this.props;
    const { password } = this.state;

    e.preventDefault();

    const response = await newPassword(email, resetKey, password);
    if (response.res.status === 200) {
      this.setState({
        passwordReset: true
      });
    }
  };

  handleInputValue = e => {
    const { name, value } = e.target;

    this.setState({
      [name]: value
    });
  };

  render() {
    const { invertedTheme, loggingIn, loginError } = this.props;
    const { passwordReset } = this.state;

    return (
      <StyledLoginForm onSubmit={this.handleNewPassword} method="POST">
        {!passwordReset ? (
          <div>
            <LoginFormTitle inverted={invertedTheme}>
              Nytt passord
            </LoginFormTitle>
            <LoginInputLabel htmlFor={'password'} inverted={invertedTheme}>
              Passord
            </LoginInputLabel>
            <LoginInputField
              type="password"
              name="password"
              id="password"
              onChange={this.handleInputValue}
              disabled={loggingIn}
              inverted={invertedTheme}
              required
            />
            {loginError && (
              <LoginErrorText inverted={invertedTheme}>
                Dette passordet er allerede endret. Hvis du fortsatt ikke klarer
                å logge inn, vennligst prøv igjen.
                <br />
                <Link to="../glemt">Glemt passord</Link>
              </LoginErrorText>
            )}
            <Button type="submit" disabled={loggingIn}>
              {loggingIn ? 'Resetter passord...' : 'Reset passord'}
            </Button>
          </div>
        ) : (
          <LoginFormTitle inverted={invertedTheme}>
            Passordet er endret. Du kan kan nå logge inn med den nye passordet.
          </LoginFormTitle>
        )}

        <LoginLink to={`/bok/${findIdByPath()}/logg-inn`}>
          Tilbake til innlogging
        </LoginLink>
      </StyledLoginForm>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginNewPassword.js